var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevSandboxAssets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.7 1.34998C1.98392 1.34998 1.29716 1.63444 0.790812 2.14079C0.284464 2.64714 0 3.33389 0 4.04998V13.95C0 14.6661 0.284464 15.3528 0.790812 15.8592C1.29716 16.3655 1.98392 16.65 2.7 16.65H15.3C16.0161 16.65 16.7028 16.3655 17.2092 15.8592C17.7155 15.3528 18 14.6661 18 13.95V4.04998C18 3.33389 17.7155 2.64714 17.2092 2.14079C16.7028 1.63444 16.0161 1.34998 15.3 1.34998H2.7ZM1.8 4.04998C1.8 3.81128 1.89482 3.58236 2.0636 3.41358C2.23239 3.2448 2.46131 3.14998 2.7 3.14998H6.8814C7.06124 3.15009 7.23692 3.20408 7.38579 3.30498C7.53466 3.40588 7.64988 3.54907 7.7166 3.71608L8.6121 5.95258C8.81246 6.45357 9.15833 6.88304 9.6051 7.18558C10.0519 7.48813 10.579 7.64989 11.1186 7.64998H16.2V13.95C16.2 14.1887 16.1052 14.4176 15.9364 14.5864C15.7676 14.7552 15.5387 14.85 15.3 14.85H2.7C2.46131 14.85 2.23239 14.7552 2.0636 14.5864C1.89482 14.4176 1.8 14.1887 1.8 13.95V4.04998ZM16.2 5.84998H11.1186C10.9388 5.84986 10.7631 5.79587 10.6142 5.69497C10.4653 5.59407 10.3501 5.45088 10.2834 5.28388L9.4293 3.14998H15.3C15.5387 3.14998 15.7676 3.2448 15.9364 3.41358C16.1052 3.58236 16.2 3.81128 16.2 4.04998V5.84998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevSandboxAssets);
export default __webpack_public_path__ + "static/media/DevSandboxAssets.431f3919795730ea1f19100f8efbf3e6.svg";
export { ForwardRef as ReactComponent };